var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28124 8.39169H1.13396C1.05996 8.39169 1 8.45169 1 8.52565V13.6837C1 13.7913 1.12042 13.855 1.20937 13.7944L6.40165 10.2594C6.47761 10.2077 6.47963 10.0973 6.40654 10.0416C5.91143 9.66454 5.55129 9.12133 5.41183 8.49669C5.39813 8.43542 5.34405 8.39169 5.28124 8.39169Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41036 5.21228V1.13396C7.41036 1.05996 7.35036 1 7.2764 1H2.07658C1.96854 1 1.90494 1.12132 1.96641 1.21019L5.58038 6.43504C5.63438 6.5131 5.74931 6.51119 5.80241 6.43247C6.15503 5.90957 6.68821 5.51629 7.31277 5.34101C7.37046 5.3248 7.41036 5.27224 7.41036 5.21228Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8272 1.92665L9.58325 5.49687C9.50497 5.55016 9.50579 5.66476 9.58372 5.7186C10.1016 6.07628 10.4877 6.60921 10.654 7.23016C10.6696 7.28871 10.7225 7.32945 10.7831 7.32945H14.9026C14.9766 7.32945 15.0365 7.26946 15.0365 7.19549V2.03739C15.0366 1.9298 14.9161 1.86611 14.8272 1.92665Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1514 9.58909C9.77123 10.0594 9.23469 10.4001 8.62066 10.5327C8.55889 10.546 8.51465 10.6003 8.51465 10.6635V14.8662C8.51465 14.9402 8.57464 15.0002 8.64861 15.0002H13.8484C13.9565 15.0002 14.0201 14.8788 13.9586 14.79L10.3662 9.59631C10.3152 9.52248 10.2079 9.51926 10.1514 9.58909Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04618 9.66406C9.01876 9.66406 9.8072 8.88184 9.8072 7.91693C9.8072 6.95202 9.01876 6.1698 8.04618 6.1698C7.07359 6.1698 6.28516 6.95202 6.28516 7.91693C6.28516 8.88184 7.07359 9.66406 8.04618 9.66406Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.5cbd7811.svg";
export { ForwardRef as ReactComponent };